import React from 'react';

/**
 * Editorial, text-led privacy / data-use block.
 * - Minimal, no icons
 * - Same typographic system as the rest of the site
 */
const PrivacyInfoBlock = ({ heading, points, testid = 'privacy-info-block' }) => {
  return (
    <section
      className="max-w-3xl mx-auto px-6 md:px-0 py-16 md:py-20"
      data-testid={testid}
    >
      <p className="text-xs uppercase tracking-[0.25em] font-medium mb-5" style={{ color: '#D4820A' }}>
        Transparency
      </p>
      <h2
        className="text-3xl md:text-4xl font-normal tracking-tight mb-10"
        style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
      >
        {heading}
      </h2>

      <div className="space-y-6">
        {points.map((p, i) => (
          <p
            key={i}
            className="text-base md:text-lg leading-relaxed"
            style={{ color: '#0F2942' }}
          >
            {p}
          </p>
        ))}
      </div>
    </section>
  );
};

export default PrivacyInfoBlock;
